/* global axios */
import ApiClient from './ApiClient';

export const buildCompanyParams = (page, sort) => {
  let params = `page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

export const buildSearchParams = (query, page, sort) => {
  let params = `q=${encodeURIComponent(query)}&page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

class CompanyAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  get(params = {}) {
    const { page = 1, sort = 'name', filters } = params;
    let requestURL = `${this.url}?${buildCompanyParams(page, sort)}`;
    if (filters && filters.length) {
      requestURL += `&q_filters=${encodeURIComponent(JSON.stringify(filters))}`;
    }
    return axios.get(requestURL);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildSearchParams(query, page, sort)}`;
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(companyData) {
    return axios.post(this.url, { company: companyData });
  }

  update(id, companyData) {
    return axios.patch(`${this.url}/${id}`, { company: companyData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  import(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  export() {
    return axios.get(`${this.url}/export`);
  }

  importSample() {
    return axios.get(`${this.url}/import_sample`, { responseType: 'blob' });
  }

  getContacts(companyId, page = 1) {
    return axios.get(`${this.url}/${companyId}/contacts`, { params: { page } });
  }

  getTickets(companyId, page = 1) {
    return axios.get(`${this.url}/${companyId}/tickets`, { params: { page } });
  }

  getConversations(companyId, page = 1) {
    return axios.get(`${this.url}/${companyId}/conversations`, { params: { page } });
  }
}

export default new CompanyAPI();
